<template>
    <div>
        <b-navbar toggleable="lg" type="light" variant="success" class="fixed-top">
            <b-container>
                <b-img src="../../static/bblogo.jpg" height="48px" class="ml-4" />
                <b-navbar-brand to="/" class="brand-text">上海隽材网络技术有限公司</b-navbar-brand>
                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                <b-collapse id="nav-collapse" is-nav>
                    <b-navbar-nav  align="center" class="bg-success">
                        <b-nav-item><b-button variant="primary" to="/" class='mr-4 '>产品介绍</b-button></b-nav-item>
                        <b-nav-item><b-button variant="warning" to="/learning" class='mr-4'>精选内容</b-button></b-nav-item>
                        <b-nav-item><b-button variant="purple" to="/community" class='mr-4'>学习社区</b-button></b-nav-item>
                        <b-nav-item><b-button variant="pink" to="/aboutus" class='mr-4'>公司简介</b-button></b-nav-item>
                        <b-nav-item><b-button variant="info" id="show-btn" @click="showYzQr" class='mr-4'>在线订购</b-button></b-nav-item>
                    </b-navbar-nav>
                </b-collapse>
            </b-container>

        </b-navbar>
        <b-modal ref="my-modal" hide-footer title="购买BB Bot">
            <div class="d-block text-center">
                <h3>请扫描 二维码进入 BB Bot 在线商店!</h3>
                <b-img class="qr" src="../../static/bb-dist.png"></b-img>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
  name: 'navBarGlobal',
  methods: {
    showYzQr () {
      this.$refs['my-modal'].show()
    },
    hideModal () {
      this.$refs['my-modal'].hide()
    },
    toggleModal () {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs['my-modal'].toggle('#toggle-btn')
    }
  }
}
</script>

<style scoped>
.top-nav {
    z-index: 1000;
    font-size: 1.2rem !important;
}

.nav {
    /* color: white !important; */
    font-size: 1.2rem !important;
}
.navbar-expand-lg .navbar-nav {
    margin-top: 0;
    background-color: transparent;
}
.navbar-light .navbar-brand, .navbar-light .navbar-brand:focus, .navbar-light .navbar-brand:hover {
    color: white;
}
.brand-text {
    font-weight: bolder;
    color: white;
    text-shadow: 2px 2px 2px #333;
}
.qr {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/navBar.vue